import { REQUEST_URL } from "./host";

const common = REQUEST_URL;
const HostUrl = common + '';

/* ******************************vipss相关接口********************************/
// 账号登录
const LoginIn = common +  "iStu/stuLogin"
// 手机号登录
const PhoneLoginIn = common +  "sys/phoneLogin"
// 退出登录
const LoginOut = common +  "iStu/logout"
// 当前学生学科权限接口
const GetSubject = common + "iStu/home/getSubject"
// 当前暑期学生学科权限接口
const GetVacationSubject = common + "iStu/home/getHolidaySubject"
// 当前强基学生学科权限接口
const getConsolidatedSubject = common + "iStu/home/getConsolidatedSubject"
// 当前学生个人信息
const GetStudentInfo = common + "iStu/student/info"
// 当前学生购买记录
const GetBuysRecord = common + "iStu/student/purchaseRecord"
// 当前学生签到接口
const GetStudentSignin = common + "iStu/student/signIn"

// 错题本数据统计接口(get)
const GetWrongStatistics = common + "iStu/home/getWrongTopicBookStatistics"
// 错题辅导接口
const getWrongTopicGuidance = common + 'iStu/home/getWrongTopicGuidance';
// 错题订正-获取试题列表接口
const ExamQuestionList = common + 'iStu/home/getWrongTopicGuidance/examQuestionList';
const ExamQuestionListCapter = common + 'iStu/home/getWrongTopicGuidance/examQuestionListByCapter';
// 错题订正-提交订正试题接口
const ErrorTopicSubmit = common + "iStu/home/getWrongTopicGuidance/submit";
// 错题订正-结束订正接口
const ErrorTopicFinish = common + "iStu/home/getWrongTopicGuidance/finish";
// 错题订正-结束订正信息详情接口
const ErrorTopicResult = common + "iStu/home/getWrongTopicGuidance/result";
// 我要纠错 （反馈问题）
const ErrorTopicFeedback = common + "iStu/home/examQuestionFeedback";
const EnErrorTopicFeedback = common + "iStu/home/enExamQuestionFeedback";

const AIAnalysis = common + "iStu/home/examAIAnalysis";


// 历史任务列表
const HistorTaskList = common + "iStu/task/historyTaskList";
// 历史任务数据统计
const HistorTaskStatistics = common + "iStu/task/historyTaskStatisticsList";
// 历史任务历史记录
const HistorTaskPractise = common + "iStu/task/historyTaskPractiseList";
// 我的任务列表
const HistorMyTaskList = common + "iStu/task/list";

// 基本信息和数据统计
const SUBJECTBASEINFO = common + "iStu/subject/baseInfo";
// 切换课本-课本列表
const SUBJECTBOOKLIST = common + "iStu/subject/info";
// 切换课本=使用课本
const SUBJECTBOOKCHANGE = common + "iStu/subject/useTextbook";
// 章节列表
const SUBJECTCAPTERLIST = common + "iStu/subject/textbookCapterList";
// 科目主页 右侧章节挑战列表
const SUBJECTCAPTERHALLENGELIST = common + "iStu/subject/textbookChallengeList";
// 科目主页 右侧章节挑战列表 - 查看统计
const SUBJECTCAPTERSTATISTICS = common + "iStu/subject/getStatisticsList";
// 科目主页 右侧章节挑战列表 - 查看英汉互译章节统计
const ENSUBJECTCAPTERSTATISTICS = common + "iStu/subject/getEnStatisticsList";
// 科目主页 右侧章节挑战列表 - 查看统计 -- 常见错题
const SUBJECTWRONGTOPICLIST = common + "iStu/subject/getCommonWrongTopicList";
// 科目主页 右侧章节挑战列表 - 查看英汉互译章节统计 -- 常见错题
const ENSUBJECTWRONGTOPICLIST = common + "iStu/subject/getEnCommonWrongTopicList";
// 科目主页 右侧章节挑战列表 - 查看英汉互译章节统计 -- 查看历史详情
const ENCHALLENGELOGDETAIL = common + "iStu/subject/getEnChallengeLogDetail";


// 挑战做题页/任务做题页
// 章节挑战-获取试题 Challenge(挑战)
const CHALLENGEBYCAPTER = common + "iStu/subject/getExamQuestionListBySectionId";
// 章节挑战-交卷
const GETSKIPEXAMNUMTODAY = common + "iStu/subject/getSkipExamNumToday";
// 章节挑战-交卷
const CHALLENGEBYCAPTERSUBMIT = common + "iStu/subject/submit";
const ENCHALLENGEBYCAPTERSUBMIT = common + "iStu/subject/submitEn";
// 任务挑战--获取试题
const CHALLENGEBYTASK = common + "iStu/task/getExamQuestionListByTaskId";
// 任务挑战--交卷
const CHALLENGEBYTASKSUBMIT = common + "iStu/task/submit";
const ENCHALLENGEBYTASKSUBMIT = common + "iStu/task/submitEn";
const JANUSSESSION = common + "api/janus/session";
const VIDEOROOM = (sessionId, plugin) => common + `api/janus/${sessionId}/attach/${plugin}`;
const JANUS_MESSAGE = (sessionId, handleId) => common + `api/janus/${sessionId}/${handleId}/message`;
// 修改密码
// 发送验证码
const SENDCAPTCHA = common + "iStu/student/getCaptcha";
// 修改密码
const UPDATEPAW = common + "iStu/student/updatePassword";


export default {
    HostUrl,
    LoginIn,
    PhoneLoginIn,
    LoginOut,
    GetSubject,
    GetVacationSubject,
    getConsolidatedSubject,
    GetStudentInfo,
    GetBuysRecord,
    GetStudentSignin,
    GetWrongStatistics,
    getWrongTopicGuidance,
    ExamQuestionList,
	ExamQuestionListCapter,
    ErrorTopicSubmit,
    ErrorTopicFinish,
    ErrorTopicResult,
    ErrorTopicFeedback,
    AIAnalysis,
    EnErrorTopicFeedback,
    HistorTaskList,
    HistorTaskStatistics,
    HistorTaskPractise,
    HistorMyTaskList,
    SUBJECTBASEINFO,
    SUBJECTBOOKLIST,
    SUBJECTBOOKCHANGE,
    SUBJECTCAPTERLIST,
    SUBJECTCAPTERHALLENGELIST,
    SUBJECTCAPTERSTATISTICS,
    ENSUBJECTCAPTERSTATISTICS,
    SUBJECTWRONGTOPICLIST,
	ENSUBJECTWRONGTOPICLIST,
	ENCHALLENGELOGDETAIL,
    CHALLENGEBYCAPTER,
    CHALLENGEBYCAPTERSUBMIT,
	GETSKIPEXAMNUMTODAY,
	ENCHALLENGEBYCAPTERSUBMIT,
    CHALLENGEBYTASK,
    CHALLENGEBYTASKSUBMIT,
	ENCHALLENGEBYTASKSUBMIT,
    SENDCAPTCHA,
	JANUSSESSION,
	VIDEOROOM,
	JANUS_MESSAGE,
    UPDATEPAW
}
